// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__GYdef","responsiveNav":"Navbar_responsiveNav__unp6s","menuIcon":"Navbar_menuIcon__gvWoG"};